import { useReducer } from 'react'

enum ActionTypes {
  NEXT = 'NEXT',
  PREVIOUS = 'PREVIOUS',
  SET_STEP = 'SET_STEP',
}

type Action = { type: ActionTypes; payload?: number }

function stepReducer(state: number, action: Action): number {
  switch (action.type) {
    case ActionTypes.NEXT:
      return state + 1
    case ActionTypes.PREVIOUS:
      return state - 1
    case ActionTypes.SET_STEP:
      return action.payload ?? state
    default:
      throw new Error()
  }
}

export interface IUseStep {
  activeStep: number
  nextStep: () => void
  previousStep: () => void
  setStep: (newStep: number) => void
  isLastStep: boolean
}

interface IUseStepProps {
  initialState: number
  maxStep: number
}

const useStep = ({ initialState, maxStep }: IUseStepProps): IUseStep => {
  const [activeStep, dispatch] = useReducer(stepReducer, initialState)

  function nextStep() {
    if (activeStep < maxStep) {
      dispatch({ type: ActionTypes.NEXT })
    }
  }

  function previousStep() {
    if (activeStep > 0) {
      dispatch({ type: ActionTypes.PREVIOUS })
    }
  }

  function setStep(newStep: number) {
    if (activeStep !== newStep) {
      dispatch({ type: ActionTypes.SET_STEP, payload: newStep })
    }
  }

  const isLastStep = activeStep === maxStep

  return {
    activeStep,
    nextStep,
    previousStep,
    setStep,
    isLastStep,
  }
}

export { useStep }
